import {
    Typography,
    Stack,
    Sheet,
    RadioGroup,
    Radio,
    CircularProgress,
    Box,
} from '@mui/joy';
import { AppProfile } from '../../../components/app/App';
import LayoutSettings from '../../../components/layout/LayoutSettings';
import { usePrivacySettings } from '../../../hooks/service/usePrivacySettings';

const OPTIONS = [
    { value: 'all', label: 'Все' },
    { value: 'subscribers', label: 'На кого я подписан' },
    { value: 'nobody', label: 'Никто' },
];

function PrivacySection({ title, desc = '', value, onChange, disabled }) {
    return (
        <Box sx={{ mb: 4 }}>
            <Typography level="body-xs" sx={{ textTransform: 'uppercase', pl: 2.15 }}>
                {title}
            </Typography>
            <Sheet variant="plain" sx={{ borderRadius: '24px', p: 2, mt: 1 }}>
                <RadioGroup
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    sx={{ gap: 0.5 }}
                >
                    {OPTIONS.map((opt) => (
                        <Radio
                            key={opt.value}
                            value={opt.value}
                            label={opt.label}
                            disabled={disabled}
                            sx={{ py: 0.6 }}
                        />
                    ))}
                </RadioGroup>
            </Sheet>
            {desc && (
                <Typography level="body-xs" sx={{ pl: 2.5, mt: 1 }}>
                    {desc}
                </Typography>
            )}
        </Box>
    );
}

export default function PageSettingsPrivacy() {
    const { settings, loading, saving, update } = usePrivacySettings();

    return (
        <AppProfile title="Конфиденциальность" desc="Настройки приватности в Аквариум">
            <LayoutSettings header="Конфиденциальность">
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box>
                        <PrivacySection
                            title="Кто может мне писать"
                            desc="Распространяется только на новые чаты."
                            value={settings.whoCanMessage}
                            onChange={(v) => update({ whoCanMessage: v })}
                            disabled={saving}
                        />
                        <PrivacySection
                            title="Кто может мне звонить"
                            value={settings.whoCanCall}
                            onChange={(v) => update({ whoCanCall: v })}
                            disabled={saving}
                        />
                    </Box>
                )}
            </LayoutSettings>
        </AppProfile>
    );
}
